import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MainLayout from '../Layout/MainLayout';
import WorkflowExecutions from './WorkflowExecutions';
import ApiLogsViewer from './ApiLogsViewer';

const DebugDashboard = () => {
  const [currentView, setCurrentView] = useState('executions');
  const [selectedExecutionId, setSelectedExecutionId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const execution = searchParams.get('execution');
    const type = searchParams.get('type');

    if (execution && type === 'v2') {
      setSelectedExecutionId(execution);
      setCurrentView('api-logs');
    }
  }, [location.search]);

  const showApiLogs = (executionId) => {
    setSelectedExecutionId(executionId);
    setCurrentView('api-logs');
  };

  const backToExecutions = () => {
    setCurrentView('executions');
    setSelectedExecutionId(null);
  };

  return (
    <MainLayout title="Workflow Debug Center">
      <div className="max-w-7xl mx-auto space-y-6">
        
        {/* Header */}
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            {selectedExecutionId ? `Debug Execution: ${selectedExecutionId.substring(0, 8)}...` : 'Workflow Debug Center'}
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg">
            Debug V2 workflow executions and analyze API calls
          </p>
        </div>

        {/* Navigation */}
        <div className="flex justify-center mb-8">
          <nav className="flex space-x-1 bg-gray-100 dark:bg-gray-800 rounded-xl p-1">
            <button
              onClick={() => setCurrentView('executions')}
              className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                currentView === 'executions'
                  ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              <span>📊</span>
              <span>Workflow Executions</span>
            </button>
            {selectedExecutionId && (
              <button
                onClick={() => setCurrentView('api-logs')}
                className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                  currentView === 'api-logs'
                    ? 'bg-white dark:bg-gray-700 text-green-600 dark:text-green-400 shadow-sm'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                }`}
              >
                <span>🔧</span>
                <span>API Logs</span>
                <span className="ml-1 px-2 py-0.5 bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-400 text-xs rounded-full">
                  {selectedExecutionId.substring(0, 8)}...
                </span>
              </button>
            )}
          </nav>
        </div>

        {/* Content */}
        {currentView === 'executions' && (
          <WorkflowExecutions onShowApiLogs={showApiLogs} />
        )}
        
        {currentView === 'api-logs' && selectedExecutionId && (
          <ApiLogsViewer 
            executionId={selectedExecutionId} 
            onClose={backToExecutions}
          />
        )}
      </div>
    </MainLayout>
  );
};

export default DebugDashboard;